module.exports = __webpack_public_path__ + "img/Invasion-MELA_SpatialResearch.fb398403.png";